<template lang="pug" src="./modal.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
      this.$store.dispatch('VIEW_MODAL', false)
      document.body.classList.remove('body-stop')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/modal.vue